import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify/";
import Vuelidate from "vuelidate";
import i18n from "./plugins/i18n.js";

Vue.use(Vuelidate);

Vue.config.productionTip = false;

new Vue({
  name: "AgriPlace",
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App)
}).$mount("#app");
